<template>
    <div
        v-show="activeTab === tab.payPal"
        :key="tab.payPal"
        id="panel-paypal"
        role="tabpanel"
        aria-labelledby="tab-paypal"
        class="payment-layout__tab-content__paypal">
        <transition-group name="fade" tag="div" class="paypal-message qt-paypalcopytxt">
            <p
                v-if="paypalTokenIsPresent || $store.state.payment.payPalToken"
                key="paypal-success"
                class="paypal-message__heading paypal-message__success-heading">
                {{ paypalSuccessMessage }}
            </p>

            <div v-else key="paypal-instruction">
                <p class="paypal-message__heading">
                    {{
                        $getLocale(
                            'you_will_be_directed_to_the_paypal_website_to_complete_your_payment',
                        )
                    }}
                </p>

                <p class="paypal-message__body">
                    {{
                        $getLocale(
                            'this_will_be_saved_as_the_default_payment_method_for_your_subscription._You_can_change_your_payment_method_at_any_time_by_visiting_your_account_settings',
                        )
                    }}
                </p>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import FormState from 'aa/vue/plugins/FormState';
    import checkoutMixin from 'aa/vue/plugins/checkoutMixin';

    import Domain from 'cbs-core-ui/src/js/helpers/Domain';
    // START TEST PLOCTOPLUS-1915: center align payment page
    import CenterAlignPaymentPageAbTest from 'aa/vue/abTestRelated/CenterAlignPaymentPageAbTest';
    // END TEST PLOCTOPLUS-1915: center align payment page
    import { TAB } from 'aa/vue/FormConfig';
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        name: 'PaymentPaypalTab',
        mixins: [CenterAlignPaymentPageAbTest, FormState, checkoutMixin],
        props: {
            activeTab: {
                type: String,
                default: TAB.cc,
            },
            isEditPayment: {
                type: Boolean,
                default: false,
            },
            isFromPaymentSummary: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                countryFormClass: '',
                altPaymentFormView: false,
                payPalToken: null,
            };
        },
        mounted() {},
        computed: {
            ...mapGetters('ftc', ['getPayPalToken']),
            tab() {
                return TAB;
            },
            paypalTokenIsPresent() {
                return this.getPayPalToken?.id;
            },
            isDomestic() {
                return Domain.isDomestic();
            },
            paypalSuccessMessage() {
                return this.isDomestic
                    ? this.pageAttr.aa_payment_paypal_success_copy
                    : this.pageAttr.billing_summary_paypal_success_copy;
            },
        },
        methods: {
            ...mapMutations('ftc', ['setPayPalToken']),
        },
        destroyed() {
            this.setPayPalToken(null);
        },
    };
</script>
